import React, { Fragment } from 'react';
import styles from './ExistingCategories.module.scss';
import { Button, Container, Row, Table } from 'reactstrap';
import FilterInTable from '../../../../views/Manage/FilterInTable';

const ExistingCategories = () => {

    const data = [
        {
            parentCategory: 'Electronics',
            subCategories: [
                { name: 'Headphones', products: 150, description: 'Gadgets', status: 'Under Review' },
                { name: 'Smart phones', products: 150, description: 'Mobile phones', status: 'Active' },
                { name: 'Laptops', products: 150, description: 'Portable PCs', status: 'Active' },
            ],
        },
        {
            parentCategory: 'Electronics',
            subCategories: [
                { name: 'Headphones', products: 150, description: 'Gadgets', status: 'Active' },
                { name: 'Smart phones', products: 150, description: 'Mobile phones', status: 'Inactive' },
                { name: 'Laptops', products: 150, description: 'Portable PCs', status: 'Under Review' },
            ],
        },
        {
            parentCategory: 'Electronics',
            subCategories: [
                { name: 'Headphones', products: 150, description: 'Gadgets', status: 'Active' },
                { name: 'Smart phones', products: 150, description: 'Mobile phones', status: 'Active' },
                { name: 'Laptops', products: 150, description: 'Portable PCs', status: 'Active' },
            ],
        },
    ];

    return (
        <Container fluid className={styles.existingCategoriesContainer}>
            <div className={styles.sectionTitle}>
                <h5 className={styles.sectionSubHeading}>Manage Existing Categories</h5>
            </div>

            <div className={styles.existingCategoriesWrapper}>
                <Row className={styles.existingCategoriesRow}>
                    <FilterInTable componentName={"Existing Category"} />
                    <div className={styles.tableContainer}>
                        <Table bordered className={styles.categoryTable}>
                            <thead>
                                <tr>
                                    <th>Parent Category</th>
                                    <th>Sub-Category</th>
                                    <th>Total Products</th>
                                    <th>Description</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((category, index) => (
                                    <Fragment key={index}>
                                        {category.subCategories.map((sub, subIndex) => (
                                            <tr key={`${index}-${subIndex}`}>
                                                {subIndex === 0 && (
                                                    <td rowSpan={category.subCategories.length} className={styles.parentCategoryCell}>
                                                        {category.parentCategory}
                                                    </td>
                                                )}
                                                <td>{sub.name}</td>
                                                <td>{sub.products}</td>
                                                <td>{sub.description}</td>
                                                <td
                                                    className={
                                                        sub.status === 'Active'
                                                            ? styles.activeStatus
                                                            : sub.status === 'Inactive'
                                                                ? styles.inactiveStatus
                                                                : styles.underReviewStatus
                                                    }
                                                >
                                                    {sub.status}
                                                </td>
                                                <td>
                                                    <Button color='link' className={styles.actionLinks}>Edit</Button>
                                                    <Button color='link' className={styles.actionLinks}>Delete</Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </Fragment>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Row>
            </div>
        </Container>
    );
};

export default ExistingCategories;